module.exports = __webpack_public_path__ + "static/media/logo21.b0800bb5.png";